<!-- 个人中心 - 查看余额页 -->

<template>
  <div id="framework-content">
    <!-- 当前位置 -->
    <div class="content-position">基本信息</div>
    <!-- 内容区域 -->
    <div class="content-main">
      <!-- 手机 -->
      <div class="account-info-bar">
        <div class="detail-bar">
          <span class="bar-title">绑定手机</span>
          <span class="bar-status" v-if="userInfo.mobile"
            >已绑定手机号<b>{{ dealWithPhone }}</b
            >&nbsp;&nbsp;&nbsp;&nbsp;可用此手机号登录</span
          >
          <span class="bar-status" v-else
            >未绑定手机号，绑定手机号可直接使用手机号登录</span
          >
          <span
            class="bar-btn"
            :class="{ 'bar-btn-active': aboutMobile.bindSatus }"
            @click="aboutMobileBind()"
            ><b v-if="userInfo.mobile">更换</b>绑定手机号</span
          >
        </div>

        <transition name="info">
          <div class="detail-area" v-if="aboutMobile.bindSatus">
            <div class="detail-area-sub">
              <p class="form-item" v-show="userInfo.mobile">
                <label>原手机号</label>
                <input type="text" style="display: none" />
                <input
                  type="text"
                  @blur="checkOldMobile"
                  v-model="aboutMobile.oldNum"
                />
                <span class="form-error-tips">
                  <img
                    src="../../assets/images/personal/right.png"
                    v-if="rightIconControl.oldNum"
                  />
                  <img
                    src="../../assets/images/personal/error.png"
                    v-if="aboutMobile.oldNumTips"
                  />
                  <b>{{ aboutMobile.oldNumTips }}</b>
                </span>
              </p>
              <p class="form-item">
                <label><b v-show="userInfo.mobile">新</b>手机号</label>
                <input type="text" style="display: none" />
                <input
                  type="text"
                  @blur="checkNewMobile"
                  v-model="aboutMobile.newNum"
                />
                <span class="form-error-tips">
                  <img
                    src="../../assets/images/personal/right.png"
                    v-if="rightIconControl.newNum"
                  />
                  <img
                    src="../../assets/images/personal/error.png"
                    v-if="aboutMobile.newNumTips"
                  />
                  <b>{{ aboutMobile.newNumTips }}</b>
                </span>
              </p>
              <p class="form-item">
                <label>验证码</label>
                <input type="text" style="display: none" />
                <input
                  type="text"
                  class="form-vcode-input"
                  @blur="checkCodeMobile"
                  v-model="aboutMobile.vcode"
                />
                <button
                  class="form-btn form-vcode-btn"
                  @click="getVcode"
                  :class="{ sendMobileCodeActive: aboutMobile.getCodeIng }"
                  :disabled="aboutMobile.getCodeIng"
                >
                  {{ aboutMobile.sendButtonCon }}
                </button>
                <span class="form-error-tips">
                  <img
                    src="../../assets/images/personal/right.png"
                    v-if="!aboutMobile.vcodeTips && rightIconControl.vcode"
                  />
                  <img
                    src="../../assets/images/personal/error.png"
                    v-if="aboutMobile.vcodeTips"
                  />
                  <b>{{ aboutMobile.vcodeTips }}</b>
                </span>
              </p>
              <p class="form-item">
                <button class="form-btn form-submit" @click="bindMobileSubmit">
                  绑定手机号
                </button>
              </p>
            </div>
          </div>
        </transition>
      </div>

      <hr class="dashed-line" v-if="!aboutMobile.bindSatus" />

      <!-- 邮箱 -->
      <div class="account-info-bar">
        <div class="detail-bar">
          <span class="bar-title">绑定邮箱</span>
          <span class="bar-status" v-if="userInfo.mail"
            >已绑定邮箱<b>{{ userInfo.mail }}</b
            >&nbsp;&nbsp;&nbsp;&nbsp;可用此邮箱登录</span
          >
          <span class="bar-status" v-else
            >未绑定邮箱，绑定邮箱可直接使用邮箱登录</span
          >
          <span
            class="bar-btn"
            :class="{ 'bar-btn-active': aboutEmail.bindSatus }"
            @click="aboutEmailBind"
            v-if="!userInfo.mail"
            >绑定</span
          >
        </div>

        <transition name="info">
          <div class="detail-area" v-if="aboutEmail.bindSatus">
            <!-- 绑定邮箱 -->
            <div class="detail-area-sub">
              <p class="form-item">
                <label>邮箱</label>
                <input type="text" style="display: none" />
                <input
                  type="text"
                  @blur="checkEmail"
                  v-model="aboutEmail.email"
                />
                <span class="form-error-tips">
                  <img
                    src="../../assets/images/personal/error.png"
                    v-if="aboutEmail.emailTips"
                  />
                  <img
                    src="../../assets/images/personal/right.png"
                    v-if="rightIconControl.email"
                  />
                  <b>{{ aboutEmail.emailTips }}</b>
                </span>
              </p>
              <p class="form-item">
                <button class="form-btn form-submit" @click="bindEmailSubmit">
                  绑定邮箱
                </button>
              </p>
            </div>
          </div>
        </transition>
      </div>

      <hr class="dashed-line" v-if="!aboutEmail.bindSatus" />

      <!-- 修改密码 -->
      <div class="detail-area-password">
        <div class="detail-area-password-title">修改密码</div>
        <div class="detail-area-password-sub">
          <p class="form-item">
            <label>当前密码</label>
            <!--解决自动填充-->
            <input type="password" style="display: none" />
            <input
              type="password"
              class="current-pwd"
              @blur="checkCurrentPwd"
              v-model="passwords.currentPwd"
              autocomplete="off"
            />
            <span class="form-error-tips">
              <img
                src="../../assets/images/personal/error.png"
                v-if="passwords.currentPwdTips"
              />
              <img
                src="../../assets/images/personal/right.png"
                v-if="rightIconControl.currentPwd"
              />
              <b>{{ passwords.currentPwdTips }}</b>
            </span>
          </p>
          <p class="form-item">
            <label>新密码</label>
            <!--解决自动填充-->
            <input type="password" style="display: none" />
            <input
              type="password"
              class="new-pwd"
              @blur="checkNewPwd"
              v-model="passwords.newPwd"
              autocomplete="false"
            />
            <span class="form-error-tips">
              <img
                src="../../assets/images/personal/right.png"
                v-if="rightIconControl.newPwd"
              />
              <img
                src="../../assets/images/personal/error.png"
                v-if="passwords.newPwdTips"
              />
              <b>{{ passwords.newPwdTips }}</b>
            </span>
          </p>
          <p class="form-item">
            <label>确认密码</label>
            <!--解决自动填充-->
            <input type="password" style="display: none" />
            <input
              type="password"
              class="confirm-pwd"
              @blur="checkConfirmPwd"
              v-model="passwords.confirmPwd"
              autocomplete="false"
            />
            <span class="form-error-tips">
              <img
                src="../../assets/images/personal/right.png"
                v-if="rightIconControl.confirmPwd"
              />
              <img
                src="../../assets/images/personal/error.png"
                v-if="passwords.confirmPwdTips"
              />
              <b>{{ passwords.confirmPwdTips }}</b>
            </span>
          </p>
          <p class="form-item">
            <button
              class="form-submit form-btn"
              @click="pwdSubmit"
              :class="{ isPwdSubmit: isPwdSubmit }"
            >
              提交
            </button>
          </p>
        </div>
      </div>
    </div>

    <!-- 弹出层 -->
    <transition name="fade">
      <div class="success-tip-box" v-if="isPopupE">
        <div class="bgshade-box" @click="hideWindow('isPopupE')"></div>
        <div class="con-box">
          <p class="popupInfo">绑定邮箱成功&nbsp;!</p>
          <img src="../../assets/personal/success.png" />
          <span @click="startSearch">开始搜索</span>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="success-tip-box" v-if="isPopupM">
        <div class="bgshade-box" @click="hideWindow('isPopupM')"></div>
        <div class="con-box">
          <p class="popupInfo">绑定手机成功&nbsp;!</p>
          <img src="../../assets/personal/success.png" />
          <span @click="startSearch">开始搜索</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
//  import axios from 'axios';

export default {
  name: "accountInfo",
  data() {
    return {
      userInfo: {},
      aboutMobile: {
        oldNum: "",
        oldNumTips: "",
        newNum: "",
        newNumTips: "",
        vcode: "",
        vcodeTips: "",

        sendButtonCon: "发送验证码",

        // 状态控制
        bindSatus: false,
        newNumStatus: false,
        getCodeStatus: false,
        getCodeIng: false,
      },
      aboutEmail: {
        email: "",
        emailTips: "",

        // 状态控制
        bindSatus: false,
        emailStatus: false,
      },
      checkRes: {
        //更改密码判断结果
        currentPwdRes: false,
        newPwdRes: false,
        confirmPwdRes: false,
        consistencyRes: false,
      },
      INPUTRULES: {
        email:
          /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
        mobile:
          /^(((13[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(14[0-9]{1}))+\d{8})$/,
        zipcode: /^[0-9]{6}$/,
        password: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/,
      },
      passwords: {
        //当前密码及提示
        currentPwd: "",
        currentPwdTips: "",
        //新密码及提示
        newPwd: "",
        newPwdTips: "",
        //确认密码及提示
        confirmPwd: "",
        confirmPwdTips: "",
      },
      //密文后的手机号码
      dealWithPhone: "",
      bindEmailSuccess: false,
      bindMobileSuccess: false,
      isPopupE: false,
      isPopupM: false,
      isPwdSubmit: false,
      isTimer: false,
      rightIconControl: {
        oldNum: false,
        newNum: false,
        vcode: false,
        email: false,
        currentPwd: false,
        newPwd: false,
        confirmPwd: false,
      },
      //公钥
      pubKey: "",
    };
  },
  mounted() {
    // let path = this.$router.currentRoute.path;
    // this.$emit('childChange', path.substring(path.lastIndexOf('/')));
    this.stateInit();
    this.getEncryptPubKey();
    let params = this.$queryUrlParams();
    //邮箱绑定成功
    if (params.bindEmail && params.bindEmail == "success") {
      //更新用户信息
      this.UpdateUserInfo();
      //初始化
      this.stateInit();
      //弹出提示
      this.isPopupE = true;
    }
    //邮箱绑定失败
    if (params.bindEmail && params.bindEmail == "fail") {
      this.$store.dispatch("showMsgModal", {
        autoClose: false,
        info: decodeURIComponent(params.message) || "邮箱绑定失败",
      });
    }
    let param = params.params;
  },
  watch: {
    bindEmailSuccess() {
      //弹出层
      this.isPopupE = true;
    },
    bindMobileSuccess() {
      this.isPopupM = true;
    },
    "userInfo.mobile"() {
      this.dealWithPhone = this.dealWithMobile(this.userInfo.mobile);
    },
  },
  methods: {
    stateInit() {
      this.userInfo = this.$getLocalStorage("IP360", "user");
      //初始化手机状态
      this.dealWithPhone = this.userInfo.mobile
        ? this.dealWithMobile(this.userInfo.mobile)
        : "";
    },
    dealWithMobile(phone) {
      return phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    },
    aboutMobileBind() {
      this.aboutMobile.bindSatus = !this.aboutMobile.bindSatus;
    },
    aboutEmailBind() {
      this.aboutEmail.bindSatus = !this.aboutEmail.bindSatus;
    },
    /*
          更改密码  start
       */
    //验证当前密码
    checkCurrentPwd() {
      let pwd = this.passwords.currentPwd;

      if (pwd.length > 0) {
        if (this.INPUTRULES.password.test(pwd)) {
          this.passwords.currentPwdTips = "";
          this.rightIconControl.currentPwd = true;
          this.checkRes.currentPwdRes = true;
          this.checkConfirmPwd();
        } else {
          this.isPwdSubmit = false;
          this.passwords.currentPwdTips = "密码由至少六位数字字母组合而成";
          this.checkRes.currentPwdRes = false;
          this.rightIconControl.currentPwd = false;
        }
      } else {
        this.isPwdSubmit = false;
        this.passwords.currentPwdTips = "请输入当前密码";
        this.checkRes.currentPwdRes = false;
        this.rightIconControl.currentPwd = false;
      }
    },
    //验证新密码
    checkNewPwd() {
      let pwd = this.passwords.newPwd;

      if (pwd.length > 0) {
        if (this.INPUTRULES.password.test(pwd)) {
          this.passwords.newPwdTips = "";
          this.checkRes.newPwdRes = true;
          this.rightIconControl.newPwd = true;
          this.checkConfirmPwd();
        } else {
          this.isPwdSubmit = false;
          this.passwords.newPwdTips = "密码由至少六位数字字母组合而成";
          this.checkRes.newPwdRes = false;
          this.rightIconControl.newPwd = false;
        }
      } else {
        this.isPwdSubmit = false;
        this.passwords.newPwdTips = "请输入新密码";
        this.checkRes.newPwdRes = false;
        this.rightIconControl.newPwd = false;
      }
    },
    //确认密码及一致性
    checkConfirmPwd() {
      let pwd = this.passwords.confirmPwd;
      if (pwd.length > 0) {
        if (this.INPUTRULES.password.test(pwd)) {
          this.passwords.confirmPwdTips = "";
          this.checkRes.confirmPwdRes = true;
          //验证密码一致性
          if (
            this.passwords.newPwd.length > 0 &&
            this.passwords.confirmPwd.length > 0
          ) {
            if (this.passwords.confirmPwd !== this.passwords.newPwd) {
              this.isPwdSubmit = false;
              this.passwords.confirmPwdTips = "两次密码输入不一致，请重新输入";
              this.checkRes.consistencyRes = false;
            } else {
              this.passwords.confirmPwdTips = "";
              this.checkRes.consistencyRes = true;
              this.rightIconControl.confirmPwd = true;
              //修改提交按钮状态
              let res =
                this.checkRes.newPwdRes &&
                this.checkRes.confirmPwdRes &&
                this.checkRes.currentPwdRes;
              if (res && this.checkRes.consistencyRes) {
                this.isPwdSubmit = true;
              } else {
                this.isPwdSubmit = false;
              }
            }
          }
        } else {
          this.isPwdSubmit = false;
          this.passwords.confirmPwdTips = "密码由至少六位数字字母组合而成";
          this.checkRes.confirmPwdRes = false;
          this.rightIconControl.confirmPwd = false;
        }
      } else {
        this.isPwdSubmit = false;
        this.passwords.confirmPwdTips = "请输入确认密码";
        this.checkRes.confirmPwdRes = false;
        this.rightIconControl.confirmPwd = false;
      }
    },
    //获取公钥
    getEncryptPubKey() {
      this.$axios
        .request({
          url: "/webapi/user/getEncryptPubKey",
          method: "GET",
          params: {},
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.pubKey = res.data.datas.encryptPubKey;
          }
        });
    },
    /**
     * 通过公钥进行加密
     * data:要加密的数据
     */
    setEncrypt(data) {
      const jsRsa = new this.$jsEncrypt();
      //设置公钥
      jsRsa.setPublicKey(this.pubKey);
      //使用加密对象给数据加密
      let RsaData = jsRsa.encrypt(data);
      return RsaData;
    },
    pwdSubmit() {
      this.checkCurrentPwd();
      this.checkNewPwd();
      this.checkConfirmPwd();
      if (!this.isPwdSubmit) {
        return;
      }
      if (
        this.passwords.newPwd.length > 0 &&
        this.passwords.currentPwd.length > 0 &&
        this.passwords.confirmPwd.length > 0
      ) {
        let info = this.userInfo;
        if (info) {
          this.$axios
            .post("/webapi/user/updatePwdV2", {
              userId: info.id,
              oldEncryptPassword: this.setEncrypt(this.$md5(this.passwords.currentPwd)),
              newEncryptPassword: this.setEncrypt(this.$md5(this.passwords.newPwd)),
              token: info.token,
            })
            .then((response) => {
              let result = response.data;
              if (result.code == 200) {
                this.isPwdSubmit = false;
                this.$store.dispatch("showMsgModal", {
                  autoClose: true,
                  info: "重置密码成功",
                });
                this.passwords.currentPwd = "";
                this.passwords.newPwd = "";
                this.passwords.confirmPwd = "";

                this.rightIconControl.currentPwd = false;
                this.rightIconControl.newPwd = false;
                this.rightIconControl.confirmPwd = false;
              } else if (result.code == 102 || result.code == 103) {
              } else {
                this.$store.dispatch("showMsgModal", {
                  autoClose: false,
                  info: result.message,
                });
              }
            });
        }
      }
    },
    /*
          更改密码  end
       */
    /*

          绑定手机  start

      */
    //当前手机号
    checkOldMobile() {
      let mobileRule = this.INPUTRULES.mobile;
      let o = this.aboutMobile.oldNum;
      this.aboutMobile.oldNumTips =
        o.length > 0
          ? mobileRule.test(o)
            ? this.userInfo.mobile == o
              ? ""
              : "与原手机号不匹配"
            : "手机号不合法"
          : "请输入手机号";

      this.rightIconControl.oldNum = !Boolean(this.aboutMobile.oldNumTips);

      return !Boolean(this.aboutMobile.oldNumTips);
    },
    //新手机号
    checkNewMobile() {
      let mobileRule = this.INPUTRULES.mobile;
      let o = this.aboutMobile.newNum;
      if (o.length > 0) {
        // if(o.length>0&&!this.isTimer){
        if (mobileRule.test(o)) {
          this.$axios
            .request({
              url: "/webapi/user/checkAccount",
              method: "GET",
              params: {
                account: o,
              },
            })
            .then((response) => {
              let res = response.data;
              if (res.code == 3004) {
                // 用戶名不存在
                this.setAboutNewNum(true, "");
              } else if (res.code == 3002) {
                this.setAboutNewNum(false, "该手机号已被绑定");
              } else {
                this.setAboutNewNum(false, res.message);
              }
            });
        } else {
          this.setAboutNewNum(false, "手机号不合法");
        }
      } else {
        this.setAboutNewNum(false, "请输入手机号");
      }
    },
    setAboutNewNum(status, tips) {
      this.aboutMobile.newNumTips = tips;
      this.aboutMobile.newNumStatus = status;
      this.rightIconControl.newNum = status;
      // this.aboutMobile.getCodeStatus = status;
    },
    //获取验证码
    getVcode(e) {
    //   console.log("---------GET CODE---------");
      this.checkNewMobile();
      if (!this.aboutMobile.newNumStatus) {
        // console.log("------新手机号不可用------");
        return;
      }
    //   console.log("------准备发送验证码------");
      this.aboutMobile.getCodeIng = true;
      this.$axios
        .request({
          url: "/webapi/user/sendPhoneVerifyCodeR",
          method: "GET",
          params: {
            account: this.aboutMobile.newNum,
            type: 3,
          },
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.aboutMobile.vcodeTips = "验证码已发送";
            let time = 4;
            this.aboutMobile.sendButtonCon = time + "s后重新获取";
            let timer = setInterval(() => {
              time--;
              this.aboutMobile.sendButtonCon = time + "s后重新获取";
              if (time == -1) {
                clearInterval(timer);
                this.aboutMobile.getCodeIng = false;
                this.aboutMobile.sendButtonCon = "发送验证码";
                // this.aboutMobile.getCodeStatus = true;
                this.aboutMobile.vcodeTips = "";
              }
            }, 1000);
          } else {
            // this.aboutMobile.getCodeStatus = true;
            this.aboutMobile.getCodeIng = false;
            this.aboutMobile.vcodeTips = response.data.message;
          }
        });
    },
    //添加绑定手机检验验证码
    checkCodeMobile() {
      let secRule = this.INPUTRULES.zipcode;
      let o = this.aboutMobile.vcode;
      this.aboutMobile.vcodeTips =
        o.length > 0 ? (secRule.test(o) ? "" : "验证码不正确") : "请输入验证码";

      this.rightIconControl.vcode = !Boolean(this.aboutMobile.vcodeTips);

      return !Boolean(this.aboutMobile.vcodeTips);
    },
    //提交修改绑定手机或添加绑定手机
    bindMobileSubmit() {
      let codeRes = this.checkCodeMobile();
      let oldNumRes = this.checkOldMobile();
      this.checkNewMobile();

    //   console.log("codeRes:", codeRes);
    //   console.log("oldNumRes:", oldNumRes);
    //   console.log("newNumStatus:", this.aboutMobile.newNumStatus);

      let res = this.aboutMobile.newNumStatus && codeRes;
      res = this.userInfo.mobile ? res && oldNumRes : res;

      if (!res) return;

      console.log("是否可以提交：", res);
      this.$axios
        .request({
          url: "/webapi/user/bindPhoneNum",
          method: "GET",
          params: {
            account: this.aboutMobile.newNum,
            userId: this.userInfo.id,
            vcode: this.aboutMobile.vcode,
            token: this.userInfo.token,
          },
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.bindMobileSuccess = true;
            //更新用户信息
            this.UpdateUserInfo();
            //初始化
            this.stateInit();
            this.mobileStateInit();
            this.rightIconControl.oldNum = false;
            this.rightIconControl.newNum = false;
            this.rightIconControl.vcode = false;
          } else {
            this.aboutMobile.vcodeTips = response.data.message;
          }
        });
    },
    mobileStateInit() {
      // 提示标识还原
      this.rightIconControl.oldNum = false;
      this.rightIconControl.newNum = false;
      this.rightIconControl.vcode = false;
      // 提示还原
      this.aboutMobile.oldNumTips = "";
      this.aboutMobile.newNumTips = "";
      this.aboutMobile.vcodeTips = "";
      // 值清空
      this.aboutMobile.oldNum = "";
      this.aboutMobile.newNum = "";
      this.aboutMobile.vcode = "";
      // 更新按钮
      this.aboutMobile.sendButtonCon = "发送验证码";
      // 状态控制
      this.aboutMobile.bindSatus = false;
      this.aboutMobile.newNumStatus = false;
      this.aboutMobile.getCodeIng = false;
    },
    /*

          绑定手机  end

      */
    //更新用户信息
    UpdateUserInfo() {
      this.$axios
        .request({
          url: "/webapi/user/getUserInfo",
          method: "GET",
          params: {
            userId: this.userInfo.id,
            token: this.userInfo.token,
          },
        })
        .then((response) => {
          if (
            response.data.code == 200 &&
            response.data.datas.userInfo.lockStatus == 2
          ) {
            this.aboutMobile.newNum = "";
            this.aboutMobile.oldNum = "";
            this.aboutMobile.vcode = "";

            response.data.datas.userInfo.token = this.userInfo.token;
            response.data.datas.userInfo.timestamp = Date.now();

            let Truthso = {
              user: response.data.datas.userInfo,
            };

            // 缓存到本地
            localStorage.setItem("IP360", JSON.stringify(Truthso));
            this.$store.commit("login", response.data.datas.userInfo);

            // 更新组件userInfo
            this.userInfo = response.data.datas.userInfo;
          }
        });
    },
    /*

          邮箱  start

      */
    checkEmail() {
      let emailRule = this.INPUTRULES.email;
      let o = this.aboutEmail.email;

      if (o.length > 0) {
        if (emailRule.test(o)) {
          this.$axios
            .request({
              url: "/webapi/user/checkAccount",
              method: "GET",
              params: {
                account: o,
              },
            })
            .then((response) => {
              let res = response.data;
              if (res.code == 3004) {
                //用戶名不存在
                this.setAboutEmail(true, "");
              } else if (res.code == 3002) {
                this.setAboutEmail(false, "该邮箱已被绑定");
              } else {
                this.setAboutEmail(false, res.message);
              }
            });
        } else {
          this.setAboutEmail(false, "邮箱不合法");
        }
      } else {
        this.setAboutEmail(false, "请输入邮箱");
      }
    },
    setAboutEmail(status, tips) {
      this.aboutEmail.emailStatus = status;
      this.aboutEmail.emailTips = tips;
      this.rightIconControl.email = status;
    },
    bindEmailSubmit() {
      this.checkEmail();
      if (!this.aboutEmail.emailStatus) return;

    //   console.log("------邮件即将发送-----");
      this.$axios
        .get("/webapi/user/bindEmail", {
          params: {
            userEmail: this.aboutEmail.email,
            userId: this.userInfo.id,
            token: this.userInfo.token,
          },
        })
        .then((response) => {
          let result = response.data;
          if (result.code == 200) {
            // this.UpdateUserInfo();

            this.aboutEmail.email = "";

            this.$store.dispatch("showMsgModal", {
              autoClose: false,
              info: "发送成功，请注意查收邮件！",
            });
          } else {
            this.$store.dispatch("showMsgModal", {
              autoClose: false,
              info: result.message,
            });
          }
        });
    },
    startSearch() {
      this.$router.push("/");
    },
    /*

          邮箱  end

      */
    openPage(url) {
      window.open(url);
    },
    hideWindow(type) {
      this[type] = false;
      this.$router.push({ path: "/personal_center/account_info" });
      this.$router.go(0);
    },
  },
  //    computed: {
  //      dealWithPhone () {
  //        return this.userInfo.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
  //      }
  //    }
};
</script>

<style scoped>
.account-info-bar {
  min-height: 70px;
}
.account-info-bar .detail-bar {
  height: 70px;
  line-height: 70px;
}
.detail-bar .bar-title {
  color: #333;
  float: left;
}
.detail-bar .bar-status {
  color: #666;
  float: left;
  margin-left: 137px;
}
.detail-bar .bar-status b {
  font-weight: normal;
  color: #c45;
}
.detail-bar .bar-btn {
  float: right;
  padding-right: 18px;
  position: relative;
  color: #666;
  cursor: pointer;
  background: url("../../assets/images/personal/bottom.png") no-repeat;
  background-position: right 33px;
}
.detail-bar .bar-btn-active {
  color: #c45;
  background: url("../../assets/images/personal/top_active.png") no-repeat;
  background-position: right 33px;
}
.detail-bar .bar-btn b {
  font-weight: normal;
}
/*	.detail-bar .bar-btn:after, .detail-bar .bar-btn:before{
		content: '';
		color: #666;
		height: 0;
		width: 0;
		z-index: 2;
		border: 3px solid transparent;
		border-width: 3px 6px;
		position: absolute;
		right: -15px;
		top: 31px;
	}
	.detail-bar .bar-btn:after {
		border-top: 6px solid #fff;
	}
	.detail-bar .bar-btn:before {
		border-top: 8px solid #000;
	}*/
.detail-area {
  border: 1px solid #ddd;
  padding-top: 21px;
  background: #fcfcfc;
  padding-left: 194px;
}
.detail-area .detail-area-sub {
  width: 312px;
}
.detail-area-password {
  margin-top: 20px;
  overflow: hidden;
}
.detail-area-password .detail-area-password-title {
  float: left;
  line-height: 32px;
  color: #333;
  width: 56px;
}
.detail-area-password .detail-area-password-sub {
  float: left;
  width: 312px;
  margin-left: 138px;
}
.detail-area .detail-area-sub p.form-item,
.detail-area-password .detail-area-password-sub p.form-item {
  position: relative;
  width: 100%;
  height: 34px;
  margin-bottom: 20px;
}
.detail-area .detail-area-sub p.form-item label,
.detail-area-password .detail-area-password-sub p.form-item label {
  float: left;
  height: 34px;
  line-height: 34px;
  padding-right: 16px;
  width: 72px;
  text-align: right;
}
.detail-area .detail-area-sub p.form-item label b {
  font-weight: normal;
}
.detail-area .detail-area-sub p.form-item input,
.detail-area-password .detail-area-password-sub p.form-item input {
  float: left;
  width: 240px;
  height: 34px;
  border: 1px solid #dcdcdc;
  background: #fff;
  padding-left: 10px;
}
.detail-area .detail-area-sub p.form-item input:focus,
.detail-area-password .detail-area-password-sub p.form-item input:focus {
  border: 1px solid #d25766;
}
.detail-area .detail-area-sub p.form-item input.form-vcode-input {
  width: 138px;
}
.detail-area .detail-area-sub button.form-btn,
.detail-area-password .detail-area-password-sub p.form-item button.form-btn {
  height: 34px;
  background: #c0404b;
  text-align: center;
  color: #fff;
  border: 0;
  cursor: pointer;
  outline: 0;
}
.detail-area .detail-area-sub button.form-vcode-btn {
  width: 92px;
  float: left;
  margin-left: 10px;
}
.detail-area .detail-area-sub button.sendMobileCodeActive {
  color: #fff;
  background-color: #ccc;
  cursor: not-allowed;
}
.detail-area .detail-area-sub button.form-submit,
.detail-area-password .detail-area-password-sub p.form-item button.form-submit {
  width: 240px;
  margin-left: 72px;
}
.detail-area .detail-area-sub button.form-submit:hover,
.detail-area-password
  .detail-area-password-sub
  p.form-item
  button.form-submit:hover {
  background: #ce5660;
}
.detail-area .detail-area-sub p.form-item span.form-error-tips,
.detail-area-password
  .detail-area-password-sub
  p.form-item
  span.form-error-tips {
  color: #c45;
  min-width: 300px;
  position: absolute;
  left: 320px;
  top: 6px;
}
.detail-area .detail-area-sub p.form-item span.form-error-tips b,
.detail-area .detail-area-sub p.form-item span.form-error-tips img,
.detail-area-password
  .detail-area-password-sub
  p.form-item
  span.form-error-tips
  b,
.detail-area-password
  .detail-area-password-sub
  p.form-item
  span.form-error-tips
  img {
  font-weight: normal;
  float: left;
}
.detail-area .detail-area-sub p.form-item span.form-error-tips b,
.detail-area-password
  .detail-area-password-sub
  p.form-item
  span.form-error-tips
  b {
  margin-left: 7px;
}
.dashed-line {
  height: 1px;
  border: none;
  border-top: 1px dashed #dbdbdb;
}
/*------------------------animation style*/
.info-enter-active,
.info-leave-active {
  transition: opacity 0.5s;
}
.info-enter {
  opacity: 0;
}
.info-leave-active {
  display: none;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}

/* clear float style */
/*.clearFloat:after{
    	content: '.';
    	height: 0;
    	overflow: hidden;
    	clear: both;
    	visibility: hidden;
    	display: block;
    	cursor: pointer;
    }*/
/* account info style */
/*	.account-info-wrap{
		background: #fff;
		overflow: hidden;
		padding: 6px 47px 0;
		min-height: 610px;
		margin-bottom: 25px;
		font-size: 16px;
	}*/

/*------------------------ 选项 style*/
/*	.account-info-tab{
		height: 60px;
		line-height: 60px;
		display: flex;
		align-items: center;
		position: relative;
	}
	.account-info-tab .account-tab-title::before{
		content: '';
		width: 2px;
		height: 16px;
		background-color: #A12935;
		margin: 22px 8px 0 0;
		float: left;
	}
	.account-info-tab .account-tab-title{
		margin-right: 30px;
	}
	.account-info-tab .account-tab-explain{
		font-size: 14px;
		color: #7f7f80;
	}
	.account-info-tab .right-btn{
		position: absolute;
		right: 12px;
		bottom: 0;
		font-size: 14px;
		cursor: pointer;
		user-select:none;
	}
	.account-info-tab .show-btn b{
		display: block;
		float: right;
		position: absolute;
		top: -3px;
		right: -12px;
		transform: rotate(180deg);
		user-select:none;
	}
	.account-info-tab .show-btn b.rotate{
		top: 3px;
		transform: rotate(0deg);
	}
	.account-info-tab .bind-btn{
		color:#bb2d3c;
	}*/

/*------------------------ btn通用 style*/
/*	.tab{
		border-bottom:1px solid #f1f1f1;
	}
	.borderB{
		border:0;
	}
	.tab .btn{
		display: block;
		width: 130px;
		height: 34px;
		line-height: 34px;
		color: #fff;
		text-align: center;
		font-size: 14px;
		border-radius: 3px;
		float: left;
    cursor: pointer;
	}
	.tab .btn-cancel{
		background-color: #bbb;
		margin: 0 25px 0 82px;
	}
	.tab .btn-submit{
		background-color: #a32935;
	}*/

/*------------------------ input通用 style*/
/*	.tab form{
		padding-left: 30px;
	}
	.tab form p.form-item{
		height: 36px;
		margin-bottom: 17px;
	}
	.tab p.form-item label{
		float: left;
		width: 82px;
		height: 36px;
		line-height: 36px;
		font-size: 14px;
	}
	.tab p.form-item input{
		height: 36px;
		box-sizing: border-box;
		border-radius: 3px;
		width: 284px;
		border:1px solid #ddd;
		padding-left: 10px;
		color: #878787;
		box-shadow: 0 0 0px 1000px white inset;
	}
	.tab p.form-item b{
		font-size: 14px;
		color: #a32935;
		font-weight: normal;
		padding-left:5px;
	}
	.tab p.form-item b.md{
		float: left;
		line-height: 36px;
		padding-left: 12px;
  }
	.tab p.form-item .diseabled{
		background-color: #bbb!important;
		font-size: 12px;
	}*/
/*------------------------- 修改密码 btn style*/
/*	.change-pwd .change-pwd-submit{
		height: 34px;
		width: 284px;
		margin-left: 82px;
		line-height: 34px;
		background-color: #bbb;
    cursor: pointer;
	}
	.change-pwd .isPwdSubmit{
		background-color: #a32935
	}*/
/*------------------------- mobile way style*/
/*	.mobile-info .mobile-info-tips{
		height: 22px;
		line-height: 22px;
		font-size: 14px;
		padding-left: 30px;
	}
	.mobile-info .mobile-info-tips img{
		float: left;
		margin-right: 12px;
	}
	.mobile-info .mobile-info-tips b{
		font-weight: normal;
		float: left;
	}
	.mobile-info .change-mobile-btn{
		width:161px;
		height: 32px;
		background-color: #a32935;
		line-height: 32px;
		margin:16px 0 32px 130px;
    cursor: pointer;
	}
	.mobile-info .mobile-info-base{
		height: 20px;
		line-height: 20px;
		font-size: 14px;
		margin-bottom: 20px;
	}
	.mobile-info .mobile-security-code{
		width: 178px!important;
		margin-right: 8px;
		float: left;
	}
	.mobile-info .send-mobile-code{
		width: 99px;
		height: 37px;
		line-height: 37px;
    background-color: #fff;
    border:1px solid #ddd;
    padding: 0;
    cursor: pointer;
    color:#bbb;
	}
  .sendMobileCodeActive{
    color:#fff!important;
    background-color: #a32935!important;
    boder:0!important;
  }*/

/*------------------------popup style*/
.success-tip-box,
.bgshade-box {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.bgshade-box {
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 16px;
  filter: alpha(opacity=50);
}
.success-tip-box .con-box {
  width: 446px;
  background: #fff;
  border-radius: 5px;
  border: 1px solid #eb828c;
  position: absolute;
  left: 50%;
  top: 34%;
  margin-left: -223px;
}
.success-tip-box .con-box p {
  height: 66px;
  margin-top: 30px;
  font-size: 14px;
  line-height: 66px;
  text-align: center;
}
.success-tip-box .con-box img {
  display: block;
  margin: 0 auto;
}
.success-tip-box .con-box span {
  display: block;
  margin: 39px auto 28px;
  width: 100px;
  height: 28px;
  line-height: 28px;
  color: #fff;
  background-color: #3a3a3c;
  text-align: center;
  font-size: 14px;
  border-radius: 3px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// AccountInfo.vue?77a103d2